import intl from 'react-intl-universal'

const metaConfig = [
  {
    key: 'section',
    text: intl.get('MetaConfig.section.text'),
    default: true,
    tab: 'planning',
    description: intl.get('MetaConfig.section.description'),
  },
  {
    key: 'schedule_planning',
    text: intl.get('MetaConfig.schedulePlanning.text'),
    default: true,
    tab: 'planning',
    description: intl.get('MetaConfig.schedulePlanning.description'),
  },
  {
    key: 'media_planning',
    text: intl.get('MetaConfig.mediaPlanning.text'),
    default: true,
    tab: 'planning',
    description: intl.get('MetaConfig.mediaPlanning.description'),
  },
  {
    key: 'planned_word_count',
    text: intl.get('MetaConfig.plannedWordCount.text'),
    default: true,
    tab: 'planning',
    description: intl.get('MetaConfig.plannedWordCount.description'),
  },
  {
    key: 'planned_line_count',
    text: intl.get('MetaConfig.plannedLineCount.text'),
    default: true,
    tab: 'planning',
    description: intl.get('MetaConfig.plannedLineCount.description'),
  },
  {
    key: 'planned_inch_count',
    text: intl.get('MetaConfig.plannedInchCount.text'),
    default: true,
    tab: 'planning',
    description: intl.get('MetaConfig.plannedInchCount.description'),
  },
  {
    key: 'working_headline',
    text: intl.get('MetaConfig.workingHeadline.text'),
    default: true,
    tab: 'planning',
    description: intl.get('MetaConfig.workingHeadline.description'),
  },
  {
    key: 'author_selection',
    text: intl.get('MetaConfig.authorSelection.text'),
    default: true,
    tab: 'planning',
    description: intl.get('MetaConfig.authorSelection.description'),
  },
  {
    key: 'created_date',
    text: intl.get('MetaConfig.createdDate.text'),
    default: true,
    tab: 'meta',
    description: intl.get('MetaConfig.createdDate.description'),
  },
  {
    key: 'last_updated_date',
    text: intl.get('MetaConfig.lastUpdatedDate.text'),
    default: true,
    tab: 'meta',
    description: intl.get('MetaConfig.lastUpdatedDate.description'),
  },
  {
    key: 'publish_date',
    text: intl.get('MetaConfig.publishDate.text'),
    default: true,
    tab: 'meta',
    description: intl.get('MetaConfig.publishDate.description'),
  },
  {
    key: 'first_publish_date',
    text: intl.get('MetaConfig.firstPublishDate.text'),
    default: true,
    tab: 'meta',
    description: intl.get('MetaConfig.firstPublishDate.description'),
  },
  {
    key: 'display_date',
    text: intl.get('MetaConfig.displayDate.text'),
    default: true,
    tab: 'meta',
    description: intl.get('MetaConfig.displayDate.description'),
  },
  {
    key: 'canonical_url',
    text: intl.get('MetaConfig.canonicalUrl.text'),
    default: true,
    tab: 'meta',
    description: intl.get('MetaConfig.canonicalUrl.description'),
  },
  {
    key: 'slug',
    text: intl.get('MetaConfig.slug.text'),
    default: true,
    tab: 'meta',
    description: intl.get('MetaConfig.slug.description'),
  },
  {
    key: 'subtype',
    picklist: 'single',
    text: intl.get('MetaConfig.subtype.text'),
    default: true,
    tab: 'meta',
    description: intl.get('MetaConfig.subtype.description'),
  },
  {
    key: 'copyright',
    text: intl.get('MetaConfig.copyright.text'),
    default: true,
    tab: 'meta',
    description: intl.get('MetaConfig.copyright.description'),
  },
  {
    key: 'language',
    picklist: 'single',
    text: intl.get('MetaConfig.language.text'),
    default: true,
    tab: 'meta',
    description: intl.get('MetaConfig.language.description'),
  },
  {
    key: 'description',
    text: intl.get('MetaConfig.description.text'),
    default: true,
    tab: 'meta',
    description: '',
  },
  {
    key: 'editor_note',
    text: intl.get('MetaConfig.editorNote.text'),
    default: true,
    tab: 'meta',
    description: '',
  },
  {
    key: 'location',
    text: intl.get('MetaConfig.location.text'),
    picklist: 'single',
    default: true,
    tab: 'meta',
    description: intl.get('MetaConfig.location.description'),
  },
  {
    key: 'address',
    text: intl.get('MetaConfig.address.text'),
    default: true,
    tab: 'meta',
    description: intl.get('MetaConfig.address.description'),
  },
  {
    key: 'geo',
    text: intl.get('MetaConfig.geo.text'),
    default: true,
    tab: 'meta',
    description: intl.get('MetaConfig.geo.description'),
  },
  {
    key: 'seo_keywords',
    text: intl.get('MetaConfig.seoKeywords.text'),
    default: true,
    tab: 'meta',
    path: 'taxonomy.seo_keywords',
    description: intl.get('MetaConfig.seoKeywords.description'),
  },
  {
    key: 'source_system',
    text: intl.get('MetaConfig.sourceSystem.text'),
    default: true,
    tab: 'meta',
    description: intl.get('MetaConfig.sourceSystem.description'),
  },
  {
    key: 'stock_symbols',
    text: intl.get('MetaConfig.stockSymbols.text'),
    default: true,
    tab: 'meta',
    path: 'taxonomy.stock_symbols',
    description: intl.get('MetaConfig.stockSymbols.description'),
  },
  {
    key: 'syndication',
    text: intl.get('MetaConfig.syndication.text'),
    default: true,
    tab: 'meta',
    description: '',
  },
  {
    key: 'corrections',
    text: intl.get('MetaConfig.corrections.text'),
    default: true,
    tab: 'meta',
    description: intl.get('MetaConfig.corrections.description'),
  },
  {
    key: 'comments',
    text: intl.get('MetaConfig.comments.text'),
    default: true,
    tab: 'meta',
    description: intl.get('MetaConfig.comments.description'),
  },
  {
    key: 'content_restrictions',
    text: intl.get('MetaConfig.contentRestrictions.text'),
    default: true,
    tab: 'meta',
    path: 'content_restrictions.content_code',
    picklist: 'single',
    description: intl.get('MetaConfig.contentRestrictions.description'),
  },
  {
    key: 'label',
    text: intl.get('MetaConfig.label.text'),
    default: true,
    tab: 'meta',
    description: intl.get('MetaConfig.label.description'),
  },
  {
    key: 'redirect',
    text: intl.get('MetaConfig.redirect.text'),
    default: true,
    tab: 'planning',
    description: intl.get('MetaConfig.redirect.description'),
  },
  {
    key: 'distributor',
    text: intl.get('MetaConfig.distributor.text'),
    default: true,
    tab: 'meta',
    description: intl.get('MetaConfig.distributor.description'),
  },
]

export default metaConfig
